import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './UserAuth';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (!user) {
    // console.log('Please Login');
    return <Navigate to='/login' />;
  }
  return children;
};

export default ProtectedRoute;
